import React from 'react'

const MissionVision = () => {
    return (
        <>

            <section className="renvia-counter-sec bg_cover pt-70 pb-30" style={{ backgroundImage: 'url("https://nayonacademy.com/html/renvia-html/assets/images/innerpage/bg/counter-bg.png")' }}>
                <div className="container">
                    <div className="counter-wrapper text-white">
                        <div className="row">
                            <div className="col-lg-3 col-md-6 col-sm-12 item-border">
                                <div className="renvia-counter-item style-one text-center mb-40 aos-init aos-animate" data-aos-duration={1000}>
                                    <div className="content">
                                        <h2><span className="counter">100+</span><span className="symbol"> </span></h2>
                                        <p>Project Available</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 item-border">
                                {/* Renvia Counter Item */}
                                <div className="renvia-counter-item style-one text-center mb-40 aos-init aos-animate" data-aos-duration={1200}>
                                    <div className="content">
                                        <h2><span className="counter">2000+</span><span className="symbol"></span></h2>
                                        <p>Project Sold</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 item-border">
                                {/* Renvia Counter Item */}
                                <div className="renvia-counter-item style-one text-center mb-40 aos-init aos-animate" data-aos-duration={1400}>
                                    <div className="content">
                                        <h2><span className="counter">500+</span> <span className="symbol"></span></h2>
                                        <p>New Home</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 item-border">
                                {/* Renvia Counter Item */}
                                <div className="renvia-counter-item style-one text-center mb-40 aos-init aos-animate" data-aos-duration={1600}>
                                    <div className="content">
                                        <h2><span className="counter">100%</span> <span className="symbol"> </span></h2>
                                        <p>Customer Satisfaction</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="renvia-about_two pt-120 pb-120" style={{ marginTop: "-60px" }}>
                <div className="shape shape-one"><img src="https://nayonacademy.com/html/renvia-html/assets/images/home-two/about/shape1.png" alt="shape" /></div>
                <div className="shape shape-two"><img src="https://nayonacademy.com/html/renvia-html/assets/images/home-two/about/shape2.png" alt="shape" /></div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-10">
                            <div className="renvia-image-box mb-5 mb-xl-0 aos-init aos-animate" data-aos-duration={1000}>
                                <div className="renvia-image">
                                    <img src="https://nayonacademy.com/html/renvia-html/assets/images/home-two/about/about-img1.jpg" alt="about image" />
                                </div>
                                <div className="renvia-content-box">
                                    <div className="content text-center text-white">
                                        <h2>100%</h2>
                                        <p>Client Retention Rate</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-10">
                            <div className="renvia-content-box">
                                <div className="section-title">
                                    <span className="sub-title aos-init aos-animate" data-aos-duration={1000}>About Us<img src="assets/images/line2.png" alt="line" /></span>
                                    <h2 className="text-anm" aria-label="Explore Our Luxurious Home with All the Amenities">
                                        Why Choose Us?
                                    </h2>
                                </div>
                                <p data-aos-duration={1000} className="aos-init aos-animate" style={{ textAlign: "justify" }}>
                                    At Earth Bond Property, we help you find the right property with complete transparency and professional guidance. All our plots and properties are properly verified so that you can invest safely and confidently. We offer plots in prime and developing locations with great future value. Our team focuses on understanding your needs and providing the best property options. We provide budget-friendly plots and properties suitable for every investor. From property selection to documentation and registration, we assist you at every step.
                                </p>
                                <div className="renvia-tabs aos-init" data-aos-duration={1000}>
                                    <ul className="nav nav-tabs" role="tablist">
                                        <li>
                                            <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#mission" aria-selected="true" role="tab">Our Mission</button>
                                        </li>
                                        <li>
                                            <button className="nav-link" data-bs-toggle="tab" data-bs-target="#vision" aria-selected="false" tabIndex={-1} role="tab">Our Vision</button>
                                        </li>

                                    </ul>
                                </div>
                                <div className="tab-content aos-init" data-aos-duration={1200}>
                                    <div className="tab-pane fade show active" id="mission" role="tabpanel">
                                        <div className="content-box">
                                            <div className="renvia-image">
                                                <img src="assets/img/mission.webp" alt="about" />
                                            </div>
                                            <div className="content">
                                                <p style={{ textAlign: "justify" }}>Our mission at Earth Bond Property is to make property buying simple, transparent, and trustworthy.
                                                    We aim to provide verified plots and real estate opportunities that help customers build secure futures and smart investments.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="vision" role="tabpanel">
                                        <div className="content-box">
                                            <div className="renvia-image">
                                                <img src="assets/img/vision.webp" alt="about" />
                                            </div>
                                            <div className="content">
                                                <p style={{ textAlign: "justify" }}>Our vision is to become a trusted and leading real estate company by delivering reliable property solutions, creating long-term customer relationships, and contributing to the development of modern and well-planned communities.</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="renvia-button-wrap aos-init" data-aos-duration={1000}>
                                    <div className="renvia-button">
                                        <a href="about.html" className="theme-btn style-one">Know More <i className="far fa-arrow-right" /></a>
                                    </div>
                                    <div className="call-support-box">
                                        <div className="icon">
                                            <i className="far fa-phone-alt" />
                                        </div>
                                        <div className="content">
                                            <span className="title">Call Us For Any Inquiry</span>
                                            <br />
                                            <a href="tel:+91 8823000048">
                                                <h6><b>+91 8823000048</b></h6>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



        </>
    )
}

export default MissionVision